<!--  桌球室管理  -->
<template>
  <table-view
    class="snooker-room"
    :total="total"
    :query-info.sync="queryInfo"
    @reload-table="renderTable">
    <template #header>
      <view-search-form
        ref="searchFormRef"
        :queryInfo.sync="queryInfo"
        :tool-list="['campus','keyword']"
        :filter-keys="['scheduleFlag']"
        @on-search="renderTable(1)">
        <el-form-item label="状态" label-width="50px">
          <el-select v-model="queryInfo.enable" size="small">
            <el-option :value="1" label="启用" />
            <el-option :value="0" label="禁用" />
          </el-select>
        </el-form-item>
      </view-search-form>
      <div class="header-button">
        <div>
          <el-descriptions :column="1" border size="mini">
            <el-descriptions-item label-class-name="descriptions-item__label" label="教职工核销员">
              {{ writeOffers.teacherList.map(item => `${item.realName}(${item.phone})`).join(',') }}
            </el-descriptions-item>
            <el-descriptions-item label-class-name="descriptions-item__label" label="学生核销员">
              {{ writeOffers.studentList.map(item => `${item.stuName}(${item.fixedPhone})`).join(',') }}
            </el-descriptions-item>
          </el-descriptions>
        </div>
        <tool-tips-group>
          <template #content>
            <h3>操作手册</h3>
            <el-link href="https://docs.qq.com/doc/DRnppSFduZWVvb0pu" type="primary" target="_blank"><i
              class="el-icon-link"></i>桌球室操作手册
            </el-link>
          </template>
        </tool-tips-group>
        <div style="white-space: nowrap">
          <el-button v-permission="['snooker:room:add']" type="primary" plain
                     size="small"
                     @click="()=>visibleBindDialog=true"
          >绑定核销员
          </el-button>
          <el-button v-permission="['snooker:rule:edit']" class="ml-1" size="small"
                     @click="()=>visibleRuleDialog=true"
          >校区规则管理
          </el-button>
          <el-tooltip class="item" effect="dark" content="存在桌球室才能新增排期模板" placement="top-start">
            <el-button v-permission="['snooker:room:add']" :disabled="!queryInfo.campusId||!!tableData.length"
                       type="primary" plain
                       size="small" @click="()=>visibleScheduleDialog=true"
            >新增排期模板
            </el-button>
          </el-tooltip>
          <!--  目前的限制都是按照ui设计时 一个校区只能存在一个桌球室的去做出的数量限制，如果以后允许创建多个桌球室则可以去掉限制   -->
          <el-tooltip class="item" effect="dark" :content="comptuMessage" placement="top-start">
            <el-button v-permission="['snooker:room:add']" :disabled="!queryInfo.campusId||!!tableData.length"
                       type="primary" size="small"
                       @click="showDialog()"
            >新增桌球室
            </el-button>
          </el-tooltip>
        </div>
      </div>
    </template>
    <el-table :data="tableData" style="width: 100%" border stripe>
      <el-table-column prop="name" label="桌球室" min-width="200" />
      <el-table-column prop="campusName" label="校区" width="120" align="center" />
      <el-table-column label="状态" width="180" align="center">
        <template v-slot="{row}">
          <el-switch
            v-if="isEditor"
            v-model="row.enable"
            @change="handleBatSwitch(row)"
            active-color="var(--color-success)"
            :active-value="1"
            active-text="启用"
            inactive-text="禁用"
            :inactive-value="0"
          />
          <el-tag :type="+row.enable?'success':'info'"
                  v-else>
            {{ +row.enable ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="球桌" min-width="250" align="center">
        <template v-slot="{row}">
          {{ getRowTables(row) }}
        </template>
      </el-table-column>
      <el-table-column v-permission="['snooker:room:edit']" label="操作" width="300" fixed="right">
        <template v-slot="{row}">
          <template v-if="isEditor">
            <el-button type="primary" plain size="mini"
                       @click="showDialog(row.id)">编辑
            </el-button>
            <el-button v-show="row.snookerRoomSchedules.length" type="primary"
                       size="small"
                       @click="showScheduleDialog(row)"
            >排期模板
            </el-button>
          </template>
          <el-button v-permission="['snooker:room:edit']" type="primary"
                     size="small"
                     @click="showSnookerTableDialog(row)"
          >球桌管理
          </el-button>
          <el-button v-permission="['snooker:room:del']"
                     size="mini"
                     type="danger"
                     @click="del(deleteSnookerRoom, row.id,`桌球室-${row.name}`)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <BindSnookerAdminDialog :visible.sync="visibleBindDialog"
                            v-if="visibleBindDialog"
                            :campus-id="queryInfo.campusId"
                            @on-close="renderTable" />
    <!--    编辑、新增桌球室 -->
    <snooker-room-dialog ref="dialogRef"
                         :visible.sync="visibleDialog"
                         v-if="visibleDialog"
                         :campus-id="queryInfo.campusId"
                         @on-close="renderTable" />
    <!--    <SnookerTableDialog ref="tableDialogRef"-->
    <!--                        :visible.sync="visibleTableDialog"-->
    <!--                        v-if="visibleTableDialog"-->
    <!--                        :campus-id="queryInfo.campusId" />-->
    <!--  排班表  -->
    <SnookerScheduleDialog ref="dialogScheduleRef"
                           :visible.sync="visibleScheduleDialog"
                           v-if="visibleScheduleDialog"
                           :parent-campus-id="queryInfo.campusId"
                           @on-close="renderTable" />
    <!--  校区排期规则  -->
    <SnookerRuleDialog :visible.sync="visibleRuleDialog" v-if="visibleRuleDialog" />
    <!--  球桌 dialog  -->
    <SnookerTableDialog ref="dialogSnookerTableRef"
                        :visible.sync="visibleTableDialog"
                        v-if="visibleTableDialog" />
  </table-view>
</template>

<script>
import tableView from '@/vue/mixins/table-view'
import { cloneDeep } from 'lodash'
import {
  pageSnookerRoomApi,
  deleteSnookerRoom,
  listSnookerRoomStuApi,
  listSnookerRoomTeacherApi, saveSnookerRoomApi
} from '@/api/student-manage/snooker-room-api.js'
import SnookerRoomDialog from '@/views/pages/studentManage/snooker-room/components/SnookerRoomDialog.vue'
import SnookerRuleDialog from '@/views/pages/studentManage/snooker-room/components/SnookerRuleDialog.vue'
import SnookerTableDialog from '@/views/pages/studentManage/snooker-room/components/SnookerTableDialog.vue'
import BindSnookerAdminDialog from '@/views/pages/studentManage/snooker-room/components/BindSnookerAdminDialog.vue'
import SnookerScheduleDialog from '@/views/pages/studentManage/snooker-room/components/SnookerScheduleDialog.vue'

export default {
  name: 'SnookerRoom',
  mixins: [tableView],
  components: {
    SnookerScheduleDialog,
    BindSnookerAdminDialog,
    SnookerTableDialog,
    SnookerRuleDialog,
    SnookerRoomDialog
  },
  data() {
    return {
      isEditor: false,
      visibleRuleDialog: false,
      visibleTableDialog: false, // 球桌 dialog
      visibleScheduleDialog: false, // 新增排期模板
      visibleBindDialog: false, // 绑定管理员(批量)
      visibleSingleBindDialog: false, // 绑定管理员（按球场）
      managerList: [], // 桌球室管理员list
      campusInfo: {}, // 当前校区信息
      queryInfo: {
        scheduleFlag: 1, // 用于回显排班表字段，没有会不显示 snookerRoomSchedules 里的数据
        campusId: null,
        enable: null,
        userId: null
      },
      gradeYearList: [],
      writeOffers: {
        teacherList: [],
        studentList: []
      }
    }
  },
  computed: {
    comptuMessage() {
      let _message = '点击添加桌球室'
      if (this.queryInfo.campusId) {
        if (this.tableData.length) {
          _message = '当前校区已存在桌球室时，禁止添加新的桌球室。'
        }
      } else {
        _message = '请先选择校区。'
      }
      return _message
    }
  },
  watch: {
    'queryInfo.campusId'() {
      this.renderTable(1)
    }
  },
  async mounted() {
    this.isEditor = this.$store.state.login.permissionTable.includes('snooker:room:edit')
  },
  methods: {
    deleteSnookerRoom, // 删除api
    async renderTable(pageNum) {
      if (this.queryInfo.campusId) {
        await this.getManagesList(this.queryInfo.campusId)
      }
      await this.getTableData(pageSnookerRoomApi, pageNum)
    },
    // 启用、禁用
    handleBatSwitch(row) {
      const msg = row.enable ? '启用' : '禁用'
      this.$confirm(`是否确认修改${row.name}的状态为${msg}?`).then(async () => {
        try {
          await saveSnookerRoomApi(row)
          this.$message.success(`${row.name}已${msg}!`)
        } catch (e) {
        }
      }).catch(() => {
        row.enable = row.enable ? 0 : 1
        this.$message.info('已取消')
      })
    },
    getRowTables(row) {
      return row.snookerRoomTables?.map(item => item.tableNo).join(',') || '--暂无球桌,无法排期--'
    },
    // 根据校区获取教师、学生核销员
    async getManagesList(campusId) {
      if (!campusId) {
        this.writeOffers.studentList = []
        this.writeOffers.teacherList = []
        return
      }
      try {
        // 学生
        const res = await listSnookerRoomStuApi({
          campusId
        })
        this.writeOffers.studentList = res.data || []
        // 教师
        const res2 = await listSnookerRoomTeacherApi({
          campusId
        })
        this.writeOffers.teacherList = res2.data || []
      } catch (e) {
        console.error(e)
      }
    },
    // 绑定管理员模板
    showBindDialog(row) {
      this.visibleSingleBindDialog = true
      this.$nextTick(() => {
        this.$refs.dialogSingleBindRef.id = row.id
        this.$refs.dialogSingleBindRef.parentData = cloneDeep(row)
      })
    },
    // 场地排期模板
    showScheduleDialog(row) {
      this.visibleScheduleDialog = true
      this.$nextTick(() => {
        this.$refs.dialogScheduleRef.parentData = cloneDeep(row)
      })
    },
    // 球桌管理 dialog
    showSnookerTableDialog(row) {
      this.visibleTableDialog = true
      this.$nextTick(() => {
        this.$refs.dialogSnookerTableRef.parentData = cloneDeep(row)
      })
    }
  }
}
</script>
<style lang="scss">
.snooker-room {
  .header-button {
    .descriptions-item__label {
      width: 100px;
    }
  }
}
</style>
